import { publishDomainEvent } from '@/services/events/eventPublisher.service';
import type { MaintenanceTask } from '@/modules/maintenance/types/maintenance';

export function publishMaintenanceScheduled(
  task: MaintenanceTask,
): Promise<void> {
  return publishDomainEvent('maintenance.scheduled', {
    taskId: task.id,
    inventoryItemId: task.inventoryItemId,
    type: task.type,
    title: task.title,
    scheduledStart: task.scheduledStart,
    scheduledEnd: task.scheduledEnd,
  });
}

export function publishMaintenanceConflict(params: {
  taskId?: string;
  itemId: string;
  start: string;
  end: string;
}): Promise<void> {
  return publishDomainEvent('maintenance.conflict', {
    ...(params.taskId ? { taskId: params.taskId } : {}),
    inventoryItemId: params.itemId,
    scheduledStart: params.start,
    scheduledEnd: params.end,
  });
}

export function publishMaintenanceStarted(
  task: MaintenanceTask,
): Promise<void> {
  return publishDomainEvent('maintenance.started', {
    taskId: task.id,
    inventoryItemId: task.inventoryItemId,
    type: task.type,
    title: task.title,
    scheduledStart: task.scheduledStart,
    scheduledEnd: task.scheduledEnd,
  });
}

export function publishMaintenanceCompleted(
  task: MaintenanceTask,
): Promise<void> {
  return publishDomainEvent('maintenance.completed', {
    taskId: task.id,
    inventoryItemId: task.inventoryItemId,
    type: task.type,
    title: task.title,
    scheduledStart: task.scheduledStart,
    scheduledEnd: task.scheduledEnd,
  });
}
